import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServicingCommonStoreService } from '@common/services/servicing-common-store/servicing-common-store.service';
import { I18N_CONFIG } from '@conf/i18n.config';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { DeviceType } from '@lib/interfaces';
import { CommonLibService, ModalService } from '@lib/services';
import { ServicingBaseComponent } from '@common/components';
import { ServicingSeatmapStoreService } from '@common/services/seatmap/servicing-seatmap-store.service';
import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ServicingSeatmapConfirmSeatReservationComponent } from '@common/components/seatmap-sub-components/servicing-seatmap-confirm-seat-reservation/servicing-seatmap-confirm-seat-reservation.component';
import { ServicingSeatmapService } from '@common/services/seatmap/servicing-seatmap.service';
import { ServicingSeatmapBackupStoreService } from '@common/services/seatmap/servicing-seatmap-backup-store.service';
import { AppConstants } from '@conf/app.constants';

@Component({
  selector: 'asw-servicing-seatmap-sub-header',
  templateUrl: './seat-attribute-request-sub-header.component.html',
  styleUrls: ['./seat-attribute-request-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeatAttributeRequestSubHeaderComponent extends ServicingBaseComponent {
  /** 戻るボタン表示可否 */
  isBack: boolean = false;

  /** 初期表示サービス */
  initDisplayService?: string;

  /** 予約詳細表示タブ */
  tabShow?: string;

  /** 日本国内線であるかどうか */
  isJapanDomesticFlight: boolean = false;

  /** 確認ボタン非活性判定 */
  isDisabledConfirm: boolean = true;

  /**
   * APP内で利用する定数の定義
   */
  public appConstants = AppConstants;

  constructor(
    private _commonLibService: CommonLibService,
    private _router: Router,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private _seatmapStoreService: ServicingSeatmapStoreService,
    private __modalService: ModalService,
    private _seatmapService: ServicingSeatmapService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _servicingSeatmapBackupStoreService: ServicingSeatmapBackupStoreService
  ) {
    super(_commonLibService);
  }

  override init(): void {
    if (
      this._commonLibService.aswContextStoreService.aswContextData.lang === I18N_CONFIG.supportedLocales['ja'] &&
      this._commonLibService.aswContextStoreService.aswContextData.deviceType === DeviceType.PC
    ) {
      this.isBack = true;
    }

    this.subscribeService(this._seatmapStoreService.getServicingSeatmapModel$().pipe(), (servicingSeatmap) => {
      if (
        !!servicingSeatmap &&
        !!servicingSeatmap.pnrInfo &&
        servicingSeatmap.displayTargetBoundArrayId !== undefined &&
        servicingSeatmap.displayTargetSegmentArrayId !== undefined
      ) {
        let flight =
          servicingSeatmap.pnrInfo.air?.bounds?.[servicingSeatmap.displayTargetBoundArrayId]?.flights?.[
            servicingSeatmap.displayTargetSegmentArrayId
          ];
        if (!!flight) {
          this.isJapanDomesticFlight = flight.isJapanDomesticFlight || false;
        }
      }

      // 変更されているセグメントが存在する場合、確認ボタン非活性判定に false を設定する。
      if (!!servicingSeatmap) {
        this.isDisabledConfirm = !this._seatmapService.isSegmentChange(
          servicingSeatmap,
          servicingSeatmap.segments,
          servicingSeatmap.selectedSeatInfoList,
          servicingSeatmap.pnrInfo
        );
        this._changeDetectorRef.markForCheck();
      }
    });
  }

  override reload(): void {}
  override destroy(): void {}

  back(): void {
    this.initDisplayService = 'seatRequest';
    this.tabShow = 'service';

    // バックアップ用シートマップ共通ストアの内容でシートマップ共通ストアを更新
    this._seatmapStoreService.setServicingSeatmap(this._servicingSeatmapBackupStoreService.servicingSeatmapBackup);
    // バックアップの削除
    this._servicingSeatmapBackupStoreService.setServicingSeatmapBackup({});

    // 予約詳細表示タブに「service」を設定
    this._servicingCommonStoreService.updateServicingCommon({
      initDisplayService: this.initDisplayService,
      tabShow: this.tabShow,
      backupLanguage: 'jp',
      displayTargetSegmentId: '', // セグメントIDを破棄
    });

    // 予約詳細画面(S01-P030)に遷移
    this._router.navigate([SERVICING_ROUTES.myBooking]);
  }

  /**
   * 確認ボタン押下
   */
  confirm(): void {
    this._seatmapStoreService.updateServicingSeatmap({
      isConfirmClick: true,
    });

    const modalPart = this.__modalService.defaultBlockPart(ServicingSeatmapConfirmSeatReservationComponent);
    modalPart.type = ModalType.TYPE4;
    modalPart.modalWidth = LModalContentsWidthType.MODAL_PC_W1000;
    modalPart.closeBackEnable = true;
    modalPart.payload = this._seatmapStoreService.servicingSeatmap.lastDisplayTargetSegmentId;
    modalPart.closeEvent = () => {
      this._seatmapStoreService.updateServicingSeatmap({
        isRequiredInitDisplay: true,
        isConfirmClick: false,
      });
    };
    this.__modalService.showSubModal(modalPart);
  }
}
